module.exports = __webpack_public_path__ + "img/arrow.9a85ae05.svg";